import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './HomePage';
import SelectionPage from './SelectionPage';
import EvaluationPage from './EvaluationPage';
import ResourcesPage from './ResourcesPage';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route 
            path="/select" 
            element={
              <ProtectedRoute>
                <SelectionPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/evaluate" 
            element={
              <ProtectedRoute>
                <EvaluationPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/evaluate/:id" 
            element={
              <ProtectedRoute>
                <EvaluationPage />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
